import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from 'api/api-backend';

export const useActivityTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const logPageView = async () => {
      if (!localStorage.getItem('auth_token')) return;
      try {
        // Get page title from document or construct from path
        const path = location.pathname;
        const title = document.title;

        // Simple heuristic for entity type
        let entityType = 'page';
        if (path.includes('/report')) {
          entityType = 'report';
        } else if (path.includes('/reservation')) {
          entityType = 'reservation';
        } else if (path.includes('/settings')) {
          entityType = 'settings';
        }

        // Extract entity_id from path if it's too long (max 50 chars)
        let entityId = path;
        if (path.length > 50) {
          // Extract UUID or ID from path if present
          const uuidMatch = path.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
          entityId = uuidMatch ? uuidMatch[0] : path.substring(0, 50);
        }

        await api.post('/v1/activities/log', {
          action: 'view_page',
          entity_type: entityType,
          entity_id: entityId,
          details: {
            path,
            title,
            search: location.search,
          },
        });
      } catch (error) {
        // Silently fail for analytics to not disrupt user experience
        console.error('Failed to log activity:', error);
      }
    };

    logPageView();
  }, [location]);
};
